
import { Options, Vue } from "vue-class-component";
import Header from "@/components/Header.vue";
import Calendar from "@/components/Calendar.vue";
import { closePage, openPage } from "@/utils/patientLoggerPage";
import StorageService from "@/services/StorageService";

@Options({
  components: {
    Header,
    Calendar
  }
})
export default class Agenda extends Vue {
  viewName = "Agenda";
  patientLoggerPageId: number | undefined;
  user: any = null;

  private storageService = new StorageService();

  async mounted() {
    this.user = this.storageService.getUser();
    this.patientLoggerPageId = await openPage(
      this.viewName,
      this.user.patientsId
    );
  }

  async beforeUnmount() {
    if (this.patientLoggerPageId && this.storageService.getUser()) {
      await closePage(this.patientLoggerPageId, this.user.patientsId);
    }
  }
}
